// IM-XPR-001 (IM-UI-095) — Meus objetivos: escolher o resultado, não a ferramenta. Os cinco objetivos com situação
// e próxima ação, sempre na mesma ordem (a tela não se reorganiza conforme o andamento).
import { useResource } from '../hooks/useResource';
import { AsyncView } from '../components/States';
import { useExperience } from './ExperienceContext';
import { loadJourneyObjectives, loadPlanningOverview, loadTargetFacts, summarizeObjectives } from './data';
import { ObjectiveCards } from './ObjectiveCards';

export function Objectives() {
  const xp = useExperience();
  const { state, reload } = useResource(async (s) => {
    const [j, t, p] = await Promise.all([loadJourneyObjectives(xp.journeys, s).catch(() => ({})), loadTargetFacts(s), loadPlanningOverview(s)]);
    return summarizeObjectives(j, t, p);
  }, [xp.journeys]);
  return (
    <section aria-labelledby="page-title">
      <header className="xp-head">
        <p className="xp-eyebrow">Meus objetivos</p>
        <h1 id="page-title">O que você quer alcançar?</h1>
        <p className="xp-lead">Não escolha uma ferramenta. Escolha o resultado; o InteliMove monta o caminho e usa as análises nos bastidores.</p>
      </header>
      <AsyncView state={state} onRetry={reload} empty={null} loading="grid">
        {(items) => <ObjectiveCards items={items} headingLevel={2} />}
      </AsyncView>
    </section>
  );
}
